import { Injectable } from '@angular/core';
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { CartItem } from '../models/cart_item.model';
import { MatSnackBar } from '@angular/material/snack-bar';

import updateCartItemMutation from 'src/app/graphql/mutations/update_cart_item.mutation.graphql'
import removeCartItemMutation from 'src/app/graphql/mutations/remove_cart_item.mutation.graphql'

@Injectable()
export class CartItemService extends GraphQLService<CartItem> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  changeAmount(item: CartItem) {
    return this.push(updateCartItemMutation, {id: item.id, amount: item.amount})
  }

  removeCartItem(item: CartItem) {
    return this.push(removeCartItemMutation, {id: item.id})
  }

}
